import { useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";

function ScrollTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    if (!pathname.includes("?")) window.scrollTo({ top: 0, behavior: "auto" });
  }, [pathname]);
  return null;
}

function BackTop() {
  useEffect(() => {
    const onScroll = () => {
      const btn = document.getElementById("back-top");
      if (btn) btn.style.opacity = window.scrollY > 600 ? "1" : "0";
    };
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);
  return (
    <button
      id="back-top"
      type="button"
      onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
      aria-label="回到顶部"
      className="fixed bottom-6 right-6 z-40 flex h-11 w-11 items-center justify-center rounded-full bg-primary-500 text-background-50 opacity-0 shadow-md transition-opacity hover:bg-primary-600"
    >
      <i className="ri-arrow-up-line text-lg" aria-hidden="true" />
    </button>
  );
}

export default function SiteLayout() {
  return (
    <div className="flex min-h-screen flex-col bg-background-50">
      <ScrollTop />
      <Navbar />
      <main className="flex-1">
        <Outlet />
      </main>
      <Footer />
      <BackTop />
    </div>
  );
}